import OdooCustomerAddressView from "components/shared/OdooCustomerAddressView";
import { Link } from "react-router-dom";
import { getOriginalFileName } from "utils/string";

const CustomerView = ({ data }) => {
  const customer = data.customer;
  const odooCustomer = JSON.parse(data.odooCustomers).records[0];
  const reportData = JSON.parse(customer.reportData);

  const contacts = odooCustomer.child_ids.filter((i) => i.type === "contact");

  return (
    <div className="card text-xs">
      <div className="space-y-6">
        <div>
          <div className="flex items-center space-x-2">
            <h5>Target & Goals</h5>
          </div>
          <div className=" whitespace-pre-wrap mt-2">
            {reportData.goals || "-"}
          </div>
        </div>

        <hr />

        <div>
          <h5>Contact</h5>
          <div className="space-y-4 mt-2">
            <OdooCustomerAddressView address={odooCustomer} inline />
            {contacts.map((address) => (
              <OdooCustomerAddressView
                key={address.id}
                address={address}
                inline
              />
            ))}
          </div>
        </div>

        <hr />

        <div className="space-y-4">
          <div>
            <div className="flex items-center space-x-2">
              <label>Attachments:</label>
            </div>
            <div className="text-xs mt-1 space-y-1">
              {customer.documents.length > 0 ? (
                customer.documents.map((i) => (
                  <div key={i.id} className="w-full truncate">
                    <a href={i.uri} target="_blank" rel="noopener noreferrer">
                      {getOriginalFileName(i.uri)}
                    </a>
                  </div>
                ))
              ) : (
                <div className="text-gray-500">No attachments</div>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <label>Price List: </label>
            {customer.priceList ? (
              <Link
                to={`/sales/price-lists/${customer.priceList.id}`}
                target="_blank"
              >
                {customer.priceList.name}
              </Link>
            ) : (
              <span className="opacity-70">Not Set</span>
            )}
          </div>

          <div className="flex items-center space-x-3">
            <label className="whitespace-nowrap">Payment Terms: </label>
            {odooCustomer.property_payment_term_id ? (
              <span>{odooCustomer.property_payment_term_id.display_name}</span>
            ) : (
              <span className="opacity-70">Not Set</span>
            )}
          </div>

          <div>
            <div className="flex items-center space-x-2">
              <label>Payment Time:</label>
              <div> - </div>
            </div>
          </div>

          <div className="flex items-center space-x-6">
            <Link to={`/sales/customers/${customer.id}`} target="_blank">
              Customer Detail Page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
